<script>
import { get } from 'lodash'
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  computed: {
    tabsFieldsSchema() {
      if (!Array.isArray(this.form.questions)) {
        this.$set(this.form, 'questions', [])
      }
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.ColorSelect({
              label: 'Kolor (domyślnie Podstawowy)',
              modelPath: [this, 'form', 'color']
            }),
            new fields.Input({
              label: 'Ilość wydarzeń na starcie (domyślnie 7)',
              modelPath: [this, 'form', 'show_on_start'],
              type: 'number'
            }),
            new fields.Input({
              label: 'Ilość doładowywanych wydarzeń (domyślnie 4)',
              modelPath: [this, 'form', 'next_open'],
              type: 'number'
            }),
            new fields.Input({
              label: 'Tytuł',
              modelPath: [this, 'form', 'title'],
              multilingual: true
            }),
            new fields.WYSIWYG({
              label: 'Informacje',
              modelPath: [this, 'form', 'info'],
              multilingual: true
            }),
            new fields.Header({
              type: 'h3',
              text: 'Pytania'
            }),
            new fields.Formset({
              modelPath: [this, 'form', 'questions'],
              items: this.form.questions.map((itemQuestion, i) => {
                return {
                  headerLabel: get(this, [
                    'form',
                    'questions',
                    i,
                    'question_pl'
                  ]),
                  fields: [
                    new fields.Input({
                      label: 'Pytanie',
                      modelPath: [this, 'form', 'questions', i, 'question'],
                      multilingual: true,
                      required: true
                    }),
                    new fields.WYSIWYG({
                      label: 'Odpowiedź',
                      modelPath: [this, 'form', 'questions', i, 'answer'],
                      multilingual: true,
                      required: true
                    })
                  ]
                }
              })
            })
          ]
        }
      ]
    }
  }
}
</script>
